import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login.component';
import { AuthGuard } from './auth.guard';
//import { SharedModule } from '../shared/shared.module';
import { UserListComponent } from './user-list/user-list.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { ListGuard } from '../shared/list.guard';
import { EditGuard } from '../shared/edit.guard';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HighlightPipe } from '../shared/highlight.pipe';

@NgModule({
  imports: [
//    SharedModule,
    CommonModule,
    FormsModule,
    HighlightPipe,
    NgbModule,
//    BrowserAnimationsModule,
    // In app.module.ts
    RouterModule.forChild([
      {
        path: 'user/:id/edit', component: UserEditComponent,
          canActivate: [AuthGuard],
          canDeactivate: [EditGuard]
      },
      {
        path: 'user', component: UserListComponent,
        canActivate: [AuthGuard],
        canDeactivate: [ListGuard]
      },
      { path: 'login', component: LoginComponent, data: { ssr: false} },
    ])
  ],

  declarations: [
    LoginComponent,
    UserListComponent,
    UserEditComponent,
  ]
})
export class UserModule { }
